import { useMemo } from 'react';

import { TablePdfOptions } from 'core/Packages';
import { DateTime } from 'luxon';
import { dotSeparator } from 'ui';

import { EventCheckInTableInstance } from './instance';
import { TableHeaderInfoBox } from './pdf/TableHeaderInfoBox';
import { TableTitle } from './pdf/TableTitle';

const exportColumns = [
  EventCheckInTableInstance.columnExportHelper.create({
    header: 'Ticket Holder Last Name',
    cell: (row) => row.last_name,
  }),
  EventCheckInTableInstance.columnExportHelper.create({
    header: 'Ticket Holder First Name',
    cell: (row) => row.first_name,
  }),
  EventCheckInTableInstance.columnExportHelper.create({
    header: 'Ticket Holder Email',
    cell: (row) => row.email,
  }),
  EventCheckInTableInstance.columnExportHelper.create({
    header: 'Ticket ID',
    cell: (row) => row.uuid,
  }),
  EventCheckInTableInstance.columnExportHelper.create({
    header: 'Order No.',
    cell: (row) => row.cart_id,
  }),
  EventCheckInTableInstance.columnExportHelper.create({
    header: 'Ticket Name',
    cell: (row) => row.store_item?.name ?? '',
  }),
  EventCheckInTableInstance.columnExportHelper.create({
    header: 'Checked-in',
    cell: (row) => (row.fulfilled_at ? 'Checked-in' : 'Unused'),
  }),
];

const useCreateEventCheckInPdfOptions = ({
  eventName,
  eventDateTime,
}: {
  eventName?: string;
  eventDateTime?: string;
}): TablePdfOptions => {
  const eventDate = DateTime.fromISO(eventDateTime ?? '').toFormat('DDD');
  const eventTime = DateTime.fromISO(eventDateTime ?? '')
    .toFormat('t')
    .replace(' AM', 'am')
    .replace(' PM', 'pm');

  const subTitle = [eventName, eventDate, eventTime].join(dotSeparator);

  return useMemo(
    () => ({
      headerProps: {
        title: 'Ticket Check-in',
        subTitle,
      },
      tableHeader: <TableTitle eventName={eventName} eventDate={eventDate} eventTime={eventTime} />,
      HeaderInfoBoxElement: <TableHeaderInfoBox eventDate={eventDate} eventTime={eventTime} />,
      orientation: 'landscape',
      fileName: `Ticket Check In: ${eventName}`,
    }),
    [subTitle, eventName, eventDate, eventTime]
  );
};

export { exportColumns, useCreateEventCheckInPdfOptions };
